import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BackButton, TableData } from "../../../../../components";
import { errorAlert } from "../../../../../helpers/alerts";
import { getAllPDSProductsService, getPDSProductsService } from "services/admin/productService";
import { setPDSProducts } from "redux/slices/admin/productSlice";
import { setCredPaymentServiceProductService } from "services/admin/providerService";
import { setCurrentPaymentServiceProduct, setPaymentServiceProducts } from "redux/slices/admin/providerSlice";
import { Grid } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";
import { currencyFormatter, filterDuplicates, sortArrayBy } from "helpers/util";
import { validatePermission } from "helpers/authentication";

const CredPDSProductScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    providerCredSelected,
    paymentServiceProducts,
  } = useSelector((store) => store.providers);
  const {
    pdsProducts
  } = useSelector((state) => state.products);


  useEffect(() => {
    getAllPDSProductsService()
      .then((data) => dispatch(setPDSProducts(data)))
      .catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);

  const handlerCheck = async (row, state) => {
    setCredPaymentServiceProductService(providerCredSelected.id, row.idSegment.id, row.id, !state).then((result) => {
      dispatch(setPaymentServiceProducts(result));
    }).catch(error => errorAlert(error))
  };

  const handlerEdit = (row) => {
    dispatch(setCurrentPaymentServiceProduct(row));
    navigate('editar');
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton click={() => navigate('..')} />
        </div>
        <div className="container-title">
          <div className="title">Productos</div>
          <div className="subtitle">{providerCredSelected.name_connector}</div>
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <TableData
        dataRows={sortArrayBy(pdsProducts, a => a.name).map((item) => {
          const service = paymentServiceProducts?.find(({ idProduct }) => idProduct.id === item.id);
          return {
            ...item,
            service
          };
        })}
        dataTitle={[
          "Logo",
          "Nombre",
          "SKU",
          validatePermission('proveedores', 'comisiones', ['ver']) && "Comisión Proveedor",
          // validatePermission('proveedores', 'comisiones', ['ver']) && "Comisión Máxima Usuario",
          "Estado"
        ].filter(Boolean)}
        formatter={({ fd, name, service }) => [
          { type: "img", value: `/v3/file/${fd}/` },
          name,
          service?.sku || filterDuplicates(service?.amounts, 'sku')?.map(a => a.sku).join(', ') || '-',
          validatePermission('proveedores', 'comisiones', ['ver']) ? service?.commissionProvider ? currencyFormatter.format(service?.commissionProvider) : '-' : null,
          // validatePermission('proveedores', 'comisiones', ['ver']) ? service?.commissionUserMax ? currencyFormatter.format(service?.commissionUserMax) : '-' : null,
          { name: "state", type: "boolean", value: service?.state, disabled: !service?.sku },
        ].filter(Boolean)}
        onChecked={handlerCheck}
        actions={[
          {
            label: "Editar",
            icon: <EditOutlined />,
            onClick: (data) => {
              handlerEdit(data);
            },
          },
        ]}
      />
    </>
  );
};

export default CredPDSProductScreen;
